import React from 'react'

import { Project, ProjectAdd, ProjectSearch } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import MenuItem from 'Pods/UnifiedNavigation/Shared/MenuItem/MenuItem'
import Section from 'Pods/UnifiedNavigation/Shared/Section/Section'

// Freelance 3D projects: applications, posting and browsing.
function ProjectsSection({ locale = 'en' }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <Section divided>
      <MenuItem
        title={t('navigation.user_menu.seller.freelance')}
        url="/profile/projects"
        svgComponent={Project}
        dataName="3D Jobs Applications"
      />
      <MenuItem
        title={t('navigation.user_menu.seller.publish_project')}
        url="/3d-modeling-jobs/new"
        svgComponent={ProjectAdd}
        dataName="Post a project"
      />
      <MenuItem
        title={t('navigation.user_menu.seller.find_new_projects')}
        url="/3d-modeling-jobs/browse"
        svgComponent={ProjectSearch}
        dataName="Browse freelance jobs"
      />
    </Section>
  )
}

ProjectsSection.propTypes = {
  locale: string,
}

export default ProjectsSection
